import { DisplayValueFormatterProps } from '@tableau/widgets/lib/src/widgets/ListMenuDisplayFormatters/DisplayValueFormatter';
import * as React from 'react';

import { ExplorerStyles } from '../ExplorerStyles';

export function generateCreateContentMenuItem(
  menuTitle: string,
  iconPath: string,
  testId: string,
  disabled: boolean = false
) {
  return class CreateContentMenuItem extends React.PureComponent<DisplayValueFormatterProps> {
    getCss() {
      const classes = [disabled ? ExplorerStyles.CreateButtonContainerDisabled : ExplorerStyles.CreateButtonContainerEnabled ];
      if (this.props.isHighlighted) {
        classes.push('highlighted');
      }
      return classes.join(' ');
    }
    render() {
      /* eslint-disable jsx-a11y/alt-text */
      return (
        <div
          data-tb-test-id={'create-' + testId + '-button'}
          className={this.getCss()}
        >
          {iconPath && <img
            src={iconPath}
            className={disabled ? ExplorerStyles.CreateButtonImgDisabled : ExplorerStyles.CreateButtonImg}
          />}
          {menuTitle}
        </div>
      );
    }
  };
}
